module.exports = __webpack_public_path__ + "static/media/icon-chevron-down_blue.7ffbeeb9.svg";